export default {
  title: 'Pajak (e-Faktur)',
  customerFilterPlaceholder: 'Semua customer',
  taxYear: 'Tahun Pajak',
  taxPeriod: 'Masa Pajak',
  taxAccNo: 'NPWP',
  customerName: 'Customer',
  fullAddress: 'Alamat Lengkap',
  invoiceNo: 'No Invoice',
  shipmentTotal: 'Total Pengiriman',
  taxBaseAmount: 'Nilai DPP',
  taxAmount: 'Nilai PPN',
  netAmount: 'Nilai Total',
  downloadCsv: 'Unduh',
}
